import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import asyncAction, { isSuccessful } from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'

import CopyShiftModal from 'modules/shift_management/components/ShiftManagement/CopyShiftModal'
import { LOGIC_OPERATOR } from 'modules/shift_management/hooks/reducers/filter'
import { useFilters } from 'modules/shift_management/hooks/useFilters'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { trackAddShiftStartEvent } from 'modules/shift_management/lib/trackEvents'
import { CopyScheduleStatsResponse, Filters } from 'modules/shift_management/lib/types'
import copyScheduleStats from 'modules/shift_management/store/api/collections/copyScheduleStats'

interface Props {
  disabled?: boolean
}

// TODO: Migrate to GraphQL.
const fetchCopyScheduleStats = async (
  originalStartAt: string,
  filters: Filters
): Promise<CopyScheduleStatsResponse> => {
  const params = {
    original_start_at: originalStartAt,
    ...filters,
  }

  // FIXME: We do RPC because there are companies with too employee_ids (~900employees) and
  // with GET, it throws CORS error, but we should migrate this to backend filters.
  return await copyScheduleStats.rpc('', params)
}

const CopyShiftButton = ({ disabled }: Props) => {
  const [showModal, setShowModal] = React.useState<boolean>(false)
  const [shiftsCount, setShiftsCount] = React.useState<number>(0)
  const [restDaysCount, setRestDaysCount] = React.useState<number>(0)
  const onClose = () => setShowModal(false)
  const [{ view }] = useSchedule()
  const [{ employeeIds, teamIds, legalEntityIds, customFilters, locationIds }] = useFilters()

  const { running: submitting, performAction: onClick } = useAsyncAction(
    async () => {
      const employees = employeeIds?.length ? employeeIds.map(Number) : []

      const result = await asyncAction(
        () =>
          fetchCopyScheduleStats(view.previousPeriod.startAt, {
            employee_ids: employeeIds,
            logic_operator: LOGIC_OPERATOR.AND,
            custom_filters: customFilters,
            team_ids: teamIds,
            legal_entity_ids: legalEntityIds,
            location_ids: locationIds,
          }),
        {
          successFlash: false,
          errorFlash: true,
        }
      )

      if (isSuccessful(result)) {
        const { value } = result
        setShiftsCount(value.shifts_count)
        setRestDaysCount(value.rest_days_count)
        setShowModal(true)
        trackAddShiftStartEvent({
          view,
          impactedEmployees: employees.length,
          cellCount: value.employees_count,
          shiftType: 'copyPeriod',
          from: 'top_bar',
        })
      }
    },
    {
      successFlash: false,
      errorFlash: false,
    }
  )

  return (
    <>
      {showModal && (
        <CopyShiftModal onClose={onClose} shiftsCount={shiftsCount} restDaysCount={restDaysCount} />
      )}
      <Button
        type="secondary"
        onClick={onClick}
        disabled={submitting || disabled}
        iconName="layers-front"
      >
        {i18n.t('shift_management.actions.copy_shift')}
      </Button>
    </>
  )
}

export default CopyShiftButton
